import React from 'react';
import RegisterForm from '../components/auth/RegisterForm';

const Register: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-16">
      <RegisterForm />
    </div>
  );
};

export default Register; 